import * as React from 'react';
import { useContext } from 'react';

import type { ApolloError } from '@apollo/client';

import type { AdminSelectedPartnerSlugQuery as AdminSelectedPartnerSlugQueryType } from 'bundles/composable-page-header-admin/queries/__generated__/AdminSelectedPartnerSlugQuery';

type AdminSelectedPartnerSlugContextType = {
  adminSelectedPartnerSlug?: AdminSelectedPartnerSlugQueryType;
  // To be used to indicate to page header renderers that we may want to render a fallback header as the call to get the header data failed if this is defined.
  error?: ApolloError;
};

const AdminSelectedPartnerSlugContext = React.createContext<AdminSelectedPartnerSlugContextType | undefined>(undefined);

export const useAdminSelectedPartnerSlug = () => {
  const context = useContext(AdminSelectedPartnerSlugContext);

  return {
    adminInfo: context?.adminSelectedPartnerSlug,
  };
};

export const useAdminSelectedPartnerSlugError = () => {
  const context = useContext(AdminSelectedPartnerSlugContext);

  return context?.error;
};

export default AdminSelectedPartnerSlugContext;
